const moods = [
  { mood: "Happy", implications: "Major chords" },
  { mood: "Sad", implications: "Minor chords and slower tempo" },
  { mood: "Angry", implications: "Distorted guitars and fast tempo" },
  { mood: "Excited", implications: "Upbeat rhythm and high energy" },
  { mood: "Calm", implications: "Soft dynamics and slow tempo" },
  { mood: "Romantic", implications: "Smooth melodies and gentle harmonies" },
  { mood: "Melancholic", implications: "Minor chords and reflective lyrics" },
  { mood: "Energetic", implications: "Driving beat and syncopation" },
  { mood: "Reflective", implications: "Acoustic instruments and slow pace" },
  { mood: "Hopeful", implications: "Ascending melodies and major chords" },
  { mood: "Triumphant", implications: "Bold brass and rising dynamics" },
  { mood: "Mysterious", implications: "Unresolved chords and unusual scales" },
  { mood: "Tense", implications: "Dissonance and repetitive rhythms" },
  { mood: "Cheerful", implications: "Bright instrumentation and quick tempo" },
  { mood: "Lonely", implications: "Sparse arrangement and minor keys" },
  {
    mood: "Playful",
    implications: "Bouncy rhythms and quirky instrumentation",
  },
  { mood: "Dark", implications: "Low tones and slow, brooding tempo" },
  { mood: "Dreamy", implications: "Echo effects and soft harmonies" },
  { mood: "Optimistic", implications: "Rising melodies and energetic tempo" },
  { mood: "Nostalgic", implications: "Warm tones and vintage instrumentation" },
  { mood: "Aggressive", implications: "Heavy percussion and intense dynamics" },
  { mood: "Peaceful", implications: "Smooth transitions and mellow tones" },
  { mood: "Groovy", implications: "Syncopated bass lines and steady rhythm" },
  {
    mood: "Quirky",
    implications: "Unexpected chord progressions and unusual instruments",
  },
  { mood: "Ethereal", implications: "Reverb-heavy and light textures" },
];

export default moods;
